import React from 'react'

// material ui
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Hidden from '@mui/material/Hidden'

export default function PersonCard(props) {
  const { header, desktopButtons, mobileButtons, children } = props
  return (
    <Card elevation={1}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={desktopButtons ? 6 : 12}>
            {header}
          </Grid>

          {/* desktop: small buttons */}
          {desktopButtons && (
            <Hidden smDown>
              <Grid item sm={6}>
                <Box textAlign='right'>{desktopButtons}</Box>
              </Grid>
            </Hidden>
          )}
        </Grid>

        {children}

        {/* mobile: full-width buttons */}
        {mobileButtons && (
          <Hidden smUp>
            <Box mt={2}>{mobileButtons}</Box>
          </Hidden>
        )}
      </CardContent>
    </Card>
  )
}
